import React, { useState } from "react";

import { Company, Customer } from "../../core/api/models";
import { CreateCompany } from "../leads/components";

const AddCompany: React.FunctionComponent<{
  onClose?: () => void;
  onCreateCompany?: (id?: string) => void;
  companyId?: string;
  onCreateCompanyWithData?: (data?: Company) => void;
}> = (props) => {
  return (
    <>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
          <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Add Company</h5>
            </div>
          </div>
        </div>

        <div className="container-fluid px-0 h-100">
          <div className="row no-gutters h-100">
            <div className=" col-12 border-right">
              <CreateCompany
                onCreateCompany={(details: Customer) =>
                {  props.onCreateCompany?.(details?._id)
                   props.onCreateCompanyWithData?.(details)
                }
                }
                gridColumns={3}
              ></CreateCompany>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddCompany;
